"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterPenalized = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ButtonTs = _interopRequireDefault(require("../../../../../ButtonTs"));

var _HotelCardTag = _interopRequireDefault(require("../../../../../HotelCardTag/HotelCardTag"));

var _iconsReact = require("../../../../../../icons-react");

/**
 * Примененный фильтр на поиске, выводится для пустой выдачи
 */
var FilterPenalized = function FilterPenalized(props) {
  var isMobile = props.isMobile,
      filter = props.filter,
      onChangeFilter = props.onChangeFilter;
  var filterName = filter.filterName,
      diff = filter.diff,
      filterGroupLabel = filter.filterGroupLabel,
      filterValue = filter.filterValue;

  var fullName = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !isMobile && filterGroupLabel, !isMobile && filterValue && ': ', filterValue);

  var handleClick = function handleClick(e) {
    if (!onChangeFilter) return;
    e.stopPropagation();
    onChangeFilter({
      path: filterName,
      diff: diff
    });
  };

  return onChangeFilter ? /*#__PURE__*/_react["default"].createElement(StyledButton, {
    offHover: true,
    size: "flex",
    onClick: handleClick,
    isMobile: isMobile
  }, fullName, /*#__PURE__*/_react["default"].createElement(CloseIcon, null)) : /*#__PURE__*/_react["default"].createElement(Tag, {
    type: "filterPenalized",
    text: fullName
  });
};

exports.FilterPenalized = FilterPenalized;
var StyledButton = (0, _styledComponents["default"])(_ButtonTs["default"]).withConfig({
  displayName: "FilterPenalized__StyledButton",
  componentId: "sc-1jvc1e5-0"
})(["background:#e6e9ee;border-radius:20px;color:#4d4d4d;padding:0 5px;font-size:12px;line-height:14px;letter-spacing:0.1rem;min-height:24px;border:0;text-transform:uppercase;margin:0 8px 8px 0;display:flex;align-items:center;justify-content:center;", ""], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile && "\n      max-width: 220px;\n  ";
});
var CloseIcon = (0, _styledComponents["default"])(_iconsReact.SlideCross).withConfig({
  displayName: "FilterPenalized__CloseIcon",
  componentId: "sc-1jvc1e5-1"
})(["width:8px;height:8px;margin-left:8px;stroke:#919499;flex-shrink:0;"]);
var Tag = (0, _styledComponents["default"])(_HotelCardTag["default"]).withConfig({
  displayName: "FilterPenalized__Tag",
  componentId: "sc-1jvc1e5-2"
})(["margin-right:8px;margin-bottom:4px;"]);